var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "-1 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.75C0 0.335786 0.316034 0 0.705882 0H23.2941C23.684 0 24 0.335786 24 0.75C24 1.16421 23.684 1.5 23.2941 1.5H0.705882C0.316034 1.5 0 1.16421 0 0.75Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 9.75C0 9.33579 0.316034 9 0.705882 9H23.2941C23.684 9 24 9.33579 24 9.75C24 10.1642 23.684 10.5 23.2941 10.5H0.705882C0.316034 10.5 0 10.1642 0 9.75Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.75C0 18.3358 0.316034 18 0.705882 18H23.2941C23.684 18 24 18.3358 24 18.75C24 19.1642 23.684 19.5 23.2941 19.5H0.705882C0.316034 19.5 0 19.1642 0 18.75Z",
    fill: "#FAFAFA",
    stroke: "#FAFAFA"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.ccfa058c7a91ac18ac5eddc12408d6fb.svg";
export { ForwardRef as ReactComponent };